export class TimeSeriesPrice {
  constructor(
    public date: Date,
    public price: number,
    public regularPrice: number,
    public isOffer: boolean,
    public isOutOfStock: boolean,
    public priceChangePercent: number,
    public noDataCollected: boolean
  ) { }
}
